// CUSTOM ANNOUNCEMENT BAR

 class CustomAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

          var section = document.querySelector('.announcement-bar-container')
          var sectionId = section.getAttribute('data-id')
          var height = section.getAttribute('data-section-height')

          var swiper = new Swiper(".announcement_slider--" + sectionId, {
            slidePerView: 1,
            spaceBetween: 20,
             autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
            loop:true,
            navigation: {
              nextEl: ".custom-button-next",
              prevEl: ".custom-button-prev",
            },
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-announcementbar", CustomAnnouncementBar);

// CUSTOM REVIEW SLIDER
class CustomReviewSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };

    const sectionId = this.getAttribute("data-sectionId");
 
const parent = this;
    const swiper = new Swiper(".custom-review-slider-" + sectionId, {
      slidesPerView: 3,
      spaceBetween: 44,
      navigation: {
        nextEl: parent.querySelector(".swiper-button-next"),
        prevEl: parent.querySelector(".swiper-button-prev"),
      },
      breakpoints:{
        280:{
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        600:{
          slidesPerView: 2,
          spaceBetween: 20,        
        },
        990:{
          slidesPerView: 3,
          spaceBetween: 44,        
        },
      }
    });

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("custom-review-slider", CustomReviewSlider);
